/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["mat-form-field[_ngcontent-%COMP%]{width:100%}mat-radio-group[_ngcontent-%COMP%]{margin-right:10px}mat-radio-group[_ngcontent-%COMP%]   mat-error[_ngcontent-%COMP%]{font-size:13px}.mat-form-field-wrapper[_ngcontent-%COMP%]{padding-top:7px}"];
export { styles as styles };
